import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhiteLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 95 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75375 26.42C4.75375 27.7479 3.69041 28.8103 2.38939 28.8103H0V2.39032C0 1.07501 1.06334 0 2.36437 0H4.74124V10.1557C6.29247 9.18186 8.11891 8.61273 10.0705 8.61273C15.6123 8.61273 20.1034 13.1278 20.1534 18.7052V26.42C20.1534 27.7479 19.0901 28.8103 17.789 28.8103H15.4122V18.8064C15.4122 14.6834 12.6725 13.0266 10.083 13.0266C7.44338 13.0266 4.75375 14.6834 4.75375 18.8064V26.42Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.8392 24.5861C31.3622 24.5861 29.2606 22.9926 28.4599 20.7666H41.9706C43.0339 20.7666 43.9096 19.9066 43.9096 18.819C43.9096 18.8063 43.9096 18.8063 43.9096 18.7937C43.9096 13.1151 39.3185 8.52417 33.6766 8.60005C28.2473 8.67593 23.8063 13.153 23.7312 18.6546C23.6561 24.3458 28.1972 29 33.8142 29C37.5171 29 40.7571 26.9764 42.5085 23.9664L40.8197 22.9799C39.3185 22.1958 38.005 22.8661 37.1793 23.4731C36.2536 24.1687 35.0902 24.5861 33.8392 24.5861ZM33.8392 13.0266C36.3161 13.0266 38.4178 14.6201 39.2184 16.846H28.4724C29.2606 14.6201 31.3622 13.0266 33.8392 13.0266Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.8769 28.8103H47.5V2.39032C47.5 1.06236 48.5633 0 49.8644 0H52.2413V26.42C52.2538 27.7353 51.1904 28.8103 49.8769 28.8103Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.3844 28.8103H57.0075V2.39032C57.0075 1.06236 58.0708 0 59.3719 0H61.7487V26.42C61.7487 27.7353 60.6854 28.8103 59.3844 28.8103Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8794 28.8105H66.5025V11.4333C66.5025 10.1053 67.5658 9.04297 68.8669 9.04297H71.2438V26.4202C71.2563 27.7355 70.1929 28.8105 68.8794 28.8105Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8794 4.80598H66.5025V2.40301C66.5025 1.07506 67.5658 0.0126953 68.8669 0.0126953H71.2438V2.41566C71.2563 3.73097 70.1929 4.80598 68.8794 4.80598Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.917 8.5874C79.3501 8.5874 74.834 13.153 74.834 18.781C74.834 24.409 79.3501 28.9747 84.917 28.9747C90.4839 28.9747 95 24.409 95 18.781C95 13.1404 90.4839 8.5874 84.917 8.5874ZM84.917 24.5482C81.7645 24.5482 79.2 21.9681 79.2 18.7684C79.2 15.5687 81.752 12.9886 84.917 12.9886C88.0695 12.9886 90.634 15.5687 90.634 18.7684C90.634 21.9681 88.0695 24.5482 84.917 24.5482Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgWhiteLogo);
export { ForwardRef as ReactComponent };
